import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { Node } from '@alfresco/js-api';
import { NodeEntityEvent } from '@alfresco/adf-content-services';
import { AppStore, UnlockWriteAction } from '@alfresco/aca-shared/store';

import { NodeVersionsDialogComponent } from '../../components/wk-node-versions/wk-node-versions.dialog';

@Component({
  templateUrl: './upload-version.dialog.html',
  encapsulation: ViewEncapsulation.None,
  host: { class: 'aca-node-versions-dialog' },
  standalone: false,
})
export class UploadVersionDialogComponent
  extends NodeVersionsDialogComponent
  implements OnInit
{
  node: Node;
  file: File;
  isTypeList = true;

  /** Emitted when a version is restored or deleted. */
  @Output()
  refreshEvent: EventEmitter<Node> = new EventEmitter<Node>();

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly matdata: any,
    private readonly customStore: Store<AppStore>,
    private readonly customDialog: MatDialogRef<UploadVersionDialogComponent>,
    customRouter: Router
  ) {
    super(matdata, customStore, customDialog, customRouter);
  }

  ngOnInit(): void {
    this.node = this.matdata.node;
    this.file = this.matdata.file;
    this.isTypeList =
      this.matdata.isTypeList !== undefined ? this.matdata.isTypeList : true;
  }

  handleUpload(nodeEvent: NodeEntityEvent) {
    if (nodeEvent.value.entry.properties['cm:lockType'] === 'WRITE_LOCK') {
      this.customStore.dispatch(new UnlockWriteAction(nodeEvent.value));
    }
    this.customDialog.close(true);
  }

  handleCancel() {
    this.customDialog.close(false);
  }
}
